import React from 'react';
import { Dialog, Text, Button, Flex } from '@applyboard/crystal-ui';
import { Intake } from '~/data';

type ChangeProgramModalProps = {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  onConfirm: () => Promise<void>;
  intake: Intake | null;
};

export function ChangeProgramModal({ open, onOpenChange, onConfirm, intake }: Readonly<ChangeProgramModalProps>) {
  const [isLoading, setIsLoading] = React.useState(false);

  async function applyChanges() {
    setIsLoading(true);
    try {
      await onConfirm();
      onOpenChange(false);
    } finally {
      setIsLoading(false);
    }
  }

  let items: { label: string; value: string }[] = [];
  if (intake) {
    items = [
      { label: 'Program Name', value: intake.programName },
      { label: 'Intake', value: intake.intakeTermName },
      { label: 'Campus', value: intake.campusName },
    ];
  }

  return (
    <Dialog open={open} onOpenChange={onOpenChange} size="md">
      <Dialog.Heading>Confirm Change Program and Intake</Dialog.Heading>
      <Dialog.Content>
        <Flex gap={4} pb={3}>
          <Text variant="bodyM">New program intake details:</Text>
        </Flex>
        <Flex gap={2} direction="column">
          {items.map((item) => (
            <Flex key={item.label} direction="row" justify="between" grow={1} aria-describedby={item.label}>
              <Text id={item.label} variant="labelL">
                {item.label}
              </Text>
              <Text variant="bodyM" aria-labelledby={item.label}>
                {item.value}
              </Text>
            </Flex>
          ))}
        </Flex>
      </Dialog.Content>
      <Dialog.Actions>
        <Dialog.CloseButton width="fill" intent="secondary" disabled={isLoading}>
          Cancel
        </Dialog.CloseButton>
        <Button width="fill" intent="primary" emphasis="contained" onClick={applyChanges} loading={isLoading}>
          Confirm
        </Button>
      </Dialog.Actions>
    </Dialog>
  );
}
